import { render, staticRenderFns } from "./TransactionSuccessDetails.vue?vue&type=template&id=33fb757b&scoped=true&"
import script from "./TransactionSuccessDetails.vue?vue&type=script&lang=ts&"
export * from "./TransactionSuccessDetails.vue?vue&type=script&lang=ts&"
import style0 from "./TransactionSuccessDetails.vue?vue&type=style&index=0&id=33fb757b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fb757b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCardSubtitle,VCardText,VCardTitle,VCol,VContainer,VIcon,VImg,VRow,VTextField})
